module.exports = __webpack_public_path__ + "static/20181018_180606(0)_optimized-e9c610836fe4b634a91d002cb3b1f7cf.jpg";